import {
	blackColors,
	dangerColor,
	formElementColors,
	hexToRgb,
	light_green,
	primaryColor,
	successColor,
	warningColor,
	whiteColor,
	formElementBaseBgColor,
} from 'assets/jss/material-dashboard-pro-react';

export const defaultFont = (theme) => ({
	fontFamily: `${theme.fontFamily.alvar.regular}, ${theme.fontFamily.albert.regular}, "Roboto", "Helvetica", "Arial", sans-serif`,
	fontWeight: 'normal',
	lineHeight: 'normal',
	letterSpacing: 'normal',
	textTransform: 'none',
});

export const defaultBodyFont = (theme) => ({
	fontWeight: 'normal',
	fontFamily: `${theme.fontFamily.albert.regular}, ${theme.fontFamily.alvar.regular}, "Roboto", "Helvetica", "Arial", sans-serif`,
	lineHeight: 'normal',
	letterSpacing: 'normal',
	textTransform: 'none',
});

function getResponsiveFont(theme, { fontSizes, lineHeights }) {
	return {
		fontSize: theme.fontSize(fontSizes[0]),
		lineHeight: theme.fontSize(lineHeights[0]),
		[theme.breakpoints.down('lg')]: {
			fontSize: theme.fontSize(fontSizes[1]),
			lineHeight: theme.fontSize(lineHeights[1]),
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: theme.fontSize(fontSizes[2]),
			lineHeight: theme.fontSize(lineHeights[2]),
		},
	};
}

const typographyStyle = (theme) => ({
	// STYLESHEET
	displayL: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		...getResponsiveFont(theme, { fontSizes: [42, 36, 32], lineHeights: [50, 44, 40] }),
	},
	displayM: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		...getResponsiveFont(theme, { fontSizes: [36, 32, 28], lineHeights: [44, 40, 36] }),
	},
	displayS: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		...getResponsiveFont(theme, { fontSizes: [32, 28, 24], lineHeights: [40, 36, 32] }),
	},
	headingL: {
		fontFamily: theme.fontFamily.alvar.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(24),
		lineHeight: theme.fontSize(30),
	},
	headingLBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(24),
		lineHeight: theme.fontSize(30),
	},
	headingXLBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(26),
		lineHeight: theme.fontSize(32),
	},
	headingM: {
		fontFamily: theme.fontFamily.alvar.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(20),
		lineHeight: theme.fontSize(26),
	},
	headingMBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(20),
		lineHeight: theme.fontSize(26),
	},
	headingS: {
		fontFamily: theme.fontFamily.alvar.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(18),
		lineHeight: theme.fontSize(24),
	},
	headingXSBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
	},
	headingSBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(18),
		lineHeight: theme.fontSize(24),
	},
	button: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(14),
		lineHeight: theme.fontSize(18),
	},
	bodyM: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
	},
	bodyL: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(18),
		lineHeight: theme.fontSize(24),
	},
	bodyMBold: {
		fontFamily: theme.fontFamily.albert.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
	},
	bodyS: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: (props) => (!props.changeFontSize ? '14px' : theme.fontSize(14)),
		lineHeight: (props) => (!props.changeFontSize ? '18px' : theme.fontSize(18)),
	},
	bodySBold: {
		fontFamily: theme.fontFamily.albert.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: (props) => (!props.changeFontSize ? '14px' : theme.fontSize(14)),
		lineHeight: (props) => (!props.changeFontSize ? '18px' : theme.fontSize(18)),
	},
	descriptionM: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(24),
	},
	descriptionS: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(14),
		lineHeight: theme.fontSize(24),
	},
	caption: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.32px',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
	},
	captionBold: {
		fontFamily: theme.fontFamily.albert.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.32px',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
	},
	captionLight: {
		fontFamily: theme.fontFamily.albert.light,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.32px',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
	},

	// PROPS STYLES
	inline: {
		display: 'inline',
	},
	disableMargin: {
		margin: 0,
	},
	useNewLine: {
		whiteSpace: 'pre-line',
	},

	// COLORS
	'primary-light': {
		color: blackColors[1],
	},
	'secondary-light': {
		color: blackColors[2],
	},
	'disabled-light': {
		color: blackColors[3],
	},
	'primary-dark': {
		color: whiteColor,
	},
	'secondary-dark': {
		color: `rgba(${hexToRgb(whiteColor)}, 0.7)`,
	},
	'disabled-dark': {
		color: `rgba(${hexToRgb(whiteColor)}, 0.51)`,
	},
	brand: ({ isNewDashboardEnabled }) => ({
		color: isNewDashboardEnabled ? formElementBaseBgColor : theme.palette.primary.main,
	}),
	'brand-secondary': {
		color: warningColor[0],
	},
	enterprise: {
		color: primaryColor[0],
	},
	success: {
		color: successColor[0],
	},
	danger: ({ isNewDashboardEnabled }) => ({
		color: isNewDashboardEnabled ? formElementColors.error : dangerColor[0],
	}),
	'float-right': {
		fontFamily: theme.fontFamily.albert.bold,
		float: 'right',
	},
	'success-light': {
		color: light_green,
	},
});

export default typographyStyle;
